import React from "react";
import { Button } from "../../shadcn/button";

const PrimaryButton = ({
  icon,
  text,
  disabled,
  onClick,
  styled,
  bgVariant,
}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      className="flex items-center justify-center w-fit gap-2 text-white font-medium px-4 py-2.5 rounded-lg border border-[#7F56D9] hover:bg-[#6941C6] disabled:opacity-50 disabled:cursor-not-allowed"
      style={{
        ...styled,
        backgroundColor: bgVariant || "#7F56D9",
        boxShadow: "0 1px 2px 0 rgba(10, 13, 18, 0.05)",
      }}
    >
      {icon}
      {text}
    </Button>
  );
};

export default PrimaryButton;
